declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    env: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    webkitSpeechRecognition: any;
    quickSightContainer: HTMLDivElement;
  }
}

type EnvType = {
  PORT: string;
  NODE_ENV: string;
  REACT_APP_CORE_API_URI: string;
  REACT_APP_LOGIN_URL: string;
  REACT_APP_FIREBASE_KEY: string;
  REACT_APP_FIREBASE_DOMAIN: string;
  REACT_APP_FIREBASE_DATABASE: string;
  REACT_APP_FIREBASE_PROJECT_ID: string;
  REACT_APP_FIREBASE_STORAGE_BUCKET: string;
  REACT_APP_FIREBASE_SENDER_ID: string;
  REACT_APP_FIREBASE_APP_ID: string;
  REACT_APP_DEVELOPMENT: string;
  REACT_APP_PRODUCTION: string;
  REACT_APP_VIDEO_CALL_PLUGIN_URL: string;
  REACT_APP_PET_WEB_URL: string;
  REACT_APP_SUBSCRIPTIONS_URI: string;
  REACT_APP_STRIPE_API_KEY: string;
  REACT_APP_STRIPE_CLIENT_ID: string;
  REACT_APP_STRIPE_CONNECT_REDIRECT_URI: string;
  REACT_APP_LOG_ROCKET_APP_ID: string;
  REACT_APP_FULL_STORY_ID: string;
  REACT_APP_SENTRY_URL: string;
  REACT_APP_TAG_MANAGER_ID: string;
  REACT_APP_PUBLIC_API_KEY: string;
  REACT_APP_SENTRY_ENVIRONMENT: string;
  REACT_APP_PROD_MIXPANEL_TOKEN: string;
  REACT_APP_DEV_MIXPANEL_TOKEN: string;
  REACT_APP_WIDGET_SHIM_URL: string;
  REACT_TEST_EMAIL: string;
  REACT_TEST_PASSWORD: string;
  REACT_APP_GIPHY_KEY: string;
  REACT_APP_AWS_JOB_ID: string;
  REACT_APP_AWS_COMMIT_ID: string;
  REACT_APP_GA4_ID: string;
  REACT_APP_LOG_ROCKET_HOSTNAME: string;
  REACT_APP_PAWBLISHER_URL: string;
  REACT_APP_CHURN_ZERO_APP_KEY: string;
  REACT_APP_CLOUDWATCH_RUM_APP_ID: string;
  REACT_APP_CLOUDWATCH_RUM_IDENTITY_POOL_ID: string;
  REACT_APP_CLOUDWATCH_RUM_ENDPOINT: string;
  REACT_APP_CLOUDWATCH_RUM_REGION: string;
  REACT_APP_IFRAME_RESIZER_LICENSE: string;
  REACT_APP_INTERCOM_APP_ID: string;
};

export const env: EnvType = { ...process.env, ...window.env };
